

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Section from 'grommet/components/Section';
import Tiles from 'grommet/components/Tiles';
import Tile from 'grommet/components/Tile';
import Card from 'grommet/components/Card';
import Button from 'grommet/components/Button';
import Box from 'grommet/components/Box';
import Headline from 'grommet/components/Headline';
import Heading from 'grommet/components/Heading';
import Paragraph from 'grommet/components/Paragraph';
import Label from 'grommet/components/Label';
import LineChartIcon from 'grommet/components/icons/base/LineChart';
import InheritIcon from 'grommet/components/icons/base/Inherit';
import DownIcon from 'grommet/components/icons/base/Down';
import Carousel from 'grommet/components/Carousel';
import Anchor from 'grommet/components/Anchor';
//import Video from 'grommet/components/Video';
//import Layer from 'grommet/components/Layer';
//import history from '../RouteHistory';
import Article from 'grommet/components/Article';
//import { Link } from 'react-router-dom'

//import { loadDashboard, unloadDashboard, searchSuggestions, navActivate, selectIndex, showUtilization } from '../../actions/actions';
import Search from 'grommet/components/Search';

class Suggestion extends Component {
  render () {
    return (
      <Box direction="row" justify="between">
        <span>{this.props.name}</span>
        <label className="secondary">
          {/*CATEGORY_LABELS[this.props.category] || this.props.category*/}
        </label>
      </Box>
    );
  }
}


export default class Home extends Component {
  contextTypes() {
    router: PropTypes.object
  }
  constructor (props) {
    super(props);
    console.log(props);
    this._onOpen = this._onOpen.bind(this);
    this._onClose = this._onClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmit9 = this.handleSubmit9.bind(this);
    this._onSearchChange = this._onSearchChange.bind(this);
    this._onSearchSelect = this._onSearchSelect.bind(this);
    this.state = { layerActive: false };
  }
  /* componentWillReceiveProps(nextProps) {
    //this._setDocumentTitle(nextProps);
    // if (this.props.nav.active !== nextProps.nav.active) {
    //   // The NavSidebar is changing, relayout when it finishes animating.
    //   // TODO: Convert to an animation event listener.
    //   this._graphicSizer.layout();
    // }
    const suggestions = nextProps.search.suggestions.map((suggestion) => {
      return {
        suggestion: suggestion,
        label: (
          <Suggestion name={suggestion.name} category={suggestion.category} />
        )
      };
    });
    this.setState({ suggestions: suggestions });
  } */
  _onOpen () {
    this.setState({layerActive: true});
  }
  _onClose () {
    this.setState({layerActive: false});
  }
  handleSubmit(event) {
    window.open(`${event}`);
  } 
  _onSearchChange (event) {
    console.log(event)
    //this.props.dispatch(searchSuggestions(event.target.value));
  }

  _onSearchSelect (pseudoEvent) {
    const suggestion = pseudoEvent.suggestion.suggestion;
    console.log(pseudoEvent)
    //this.props.dispatch(selectIndex('/' + suggestion.category, suggestion.uri));
  } 
  handleSubmit9(y) {
    const path = `/${y}`;
    console.log(path);
    
    this.context.router.push(path);
  }
  _onClick() {
    console.log("clicking")
  }
  render() {
    const { search } = this.props;
    /*  
    let dialogLayer;
    if (this.state.layerActive) {
      dialogLayer = (
        <Layer onClose={this._onClose} closer={true} align="center">
          <Box pad={{vertical: 'large'}}>
            <h2><strong>Get Started</strong></h2>
            <Paragraph>
             Data Governance Portal.
            </Paragraph>
            <Video poster={history.makeHref('/img/meg_video.jpg')} full={true}>
              <source src={history.makeHref('/video/DGP_Welcome.mp4')} type="video/mp4"/>
            </Video>
          </Box>
        </Layer>
      );
    }
    */

    //backgroundImage={`url(${history.makeHref('/img/slide-4I.jpg')})`}
    //backgroundImage={`url(${history.makeHref('/img/slide-2I.jpg')})`}
    //backgroundImage={`url(${history.makeHref('/img/slide-3I.jpg')})`}
    //backgroundImage={`url(${history.makeHref('/img/slide-1I.jpg')})`}
    //background-image: url("paper.gif");
    //backgroundImage={`url(/img/backgound.jpg)`} accent-3
    return (
	<Article className="home" scrollStep={false}>
	  <div>
	    <Box>
          <Section appCentered={true} pad="none" className="home__section"
             style={{ "background-image": "url('background3.jpg')"}}  colorIndex="dark"
            primary={true} full={true} justify="end" align="center" > 
            

            <Box
              pad={{horizontal: 'large', vertical: 'large', between: 'medium'}}
              full="horizontal" align="center"
              className="home__welcome"
			  colorIndex="light-2"
              style={{ opacity: '0.8'}}>
              {/* <Search ref="search" inline={true} responsive={false} fill={true}
            size="huge" placeHolder="Search"
            defaultValue={"search.text"} onDOMChange={this._onSearchChange}
            onSelect={this._onSearchSelect}
            suggestions={this.state.suggestions}/><br/><br/><br/> */}
			 
              <Headline size="small" strong={true} align="center" margin="none"><font size="20">
                In-browser Data Preparation Tool<br/></font>
                <Paragraph>
                  <b>
                  <Label>Evaluate assumptions in record time and no code required!</Label> <br/> 
                  </b>

                </Paragraph>
                <Label style={{fontSize: "12px"}}>Want to read the blog and story behind this? <a href="https://medium.com/@Fredy_Gomez_J/data-cleansing-and-preparation-for-machine-learning-statistic-models-fb3e84606762?sk=a972fac2e036d1ca18aeadbb1d881fe0" target="_blank" >Click here</a></Label>
              </Headline>
			  {/*
			  <Paragraph size="large" align="center" margin="none">
                <b>text here</b><br/><br/><br/></Paragraph>
			  
              <Heading align="start" tag="h4">
                <li style={{fontSize: "120%"}}>No need of setting up anything or learn a new lenguages</li>
                <li style={{fontSize: "120%"}}>All data-processing happens in the browser</li> 
                <li style={{fontSize: "120%"}}>Two modes: UI (Use workflows) or Live Edit (Code in Javascript)</li>	
              </Heading> */}
				 <Anchor href="/workflow">
                 <Button label="Get Started" onClick={this._onClick.bind(this)}/>
                 </Anchor><br/>
                 <a href="#section2"><DownIcon size="large" colorIndex="light-1" style={{cursor: "pointer"}} /></a><br/><br/><br/>
			</Box>		
          </Section>
		 <Section align="start" pad={{"horizontal": "medium", "vertical": "medium", "between": "small"}} >	  
     {/* <h2 id="section2">Use Cases</h2>
			<Tiles fill={true} flush={false}>
				<Tile colorIndex="light-1">
          <div style={{paddingTop: "80px"}}>
          <Anchor target={"_blank"} href='https://medium.com/@Fredy_Gomez_J/in-browser-machine-learning-google-sheets-prophesier-6ebc5be300a4'>
            <Card thumbnail='/img/anomaly.png'
              label='Anomaly Analysis for a Time Serie dataset'
              />
          </Anchor>
          </div>
				</Tile>
        <Tile colorIndex="light-1">
          <div style={{paddingTop: "80px"}}>
          <Anchor target={"_blank"} href='https://medium.com/@Fredy_Gomez_J/in-browser-machine-learning-predict-house-prices-using-google-sheets-and-prophesier-ca4547633f66'>
            <Card thumbnail='/img/linearregression.png'
              label='Predict House Prices using Multi linear regression'
              />
          </Anchor>
          </div>
				</Tile>
			  </Tiles>		   */}
		</Section> 
       
        </Box>
	</div>
	</Article>
	);
  }
};
Home.contextTypes = {
  router: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/Home.js